import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NotebookSessionService {
  initialized = false;

  public initialize() {
    this.initialized = true;
  }
}
